import { render } from "./SubHeader.vue?vue&type=template&id=c5350efc&scoped=true"
const script = {}

import "./SubHeader.vue?vue&type=style&index=0&id=c5350efc&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5350efc"]])

export default __exports__